import React, { useEffect, useState } from "react";
import { FiCheck, FiCopy } from "react-icons/fi";
import { hasValue } from "../../utils/data";
import { CopyIconButton } from "./styles";

export const HIDDEN_VALUE_LABEL = "••••••";
export const EMPTY_VALUE = "—";

export async function copyTextToClipboard(text) {
  if (!text) return false;
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export function resolveCopyText(value, copyText) {
  if (copyText !== undefined) return copyText;
  if (typeof value === "string" || typeof value === "number") return String(value);
  return "";
}

export function shouldShowCopy(text) {
  return hasValue(text) && text !== EMPTY_VALUE && text !== HIDDEN_VALUE_LABEL;
}

export function CopyButton({ text, label, compact = false }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const id = window.setTimeout(() => setCopied(false), 1500);
    return () => window.clearTimeout(id);
  }, [copied]);

  async function handleCopy(event) {
    event.stopPropagation();
    const ok = await copyTextToClipboard(text);
    if (ok) setCopied(true);
  }

  const iconSize = compact ? 11 : 13;

  return (
    <CopyIconButton
      type="button"
      onClick={handleCopy}
      title={copied ? "Copiado!" : `Copiar ${label}`}
      aria-label={copied ? "Copiado" : `Copiar ${label}`}
      $copied={copied}
      $compact={compact}
    >
      {copied ? <FiCheck size={iconSize} /> : <FiCopy size={iconSize} />}
    </CopyIconButton>
  );
}
